import { render, staticRenderFns } from "./ConsumerDashboardSmartPrepaid_old.vue?vue&type=template&id=49dfa52c&scoped=true&"
import script from "./ConsumerDashboardSmartPrepaid_old.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboardSmartPrepaid_old.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboardSmartPrepaid_old.vue?vue&type=style&index=0&id=49dfa52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dfa52c",
  null
  
)

export default component.exports